import { DateField, NumberField, Show, SimpleShowLayout, TextField } from "react-admin";

export const FilesShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <TextField source="encoding" />
            <TextField source="filename" />
            <TextField source="mimetype" />
            <TextField source="originalname" />
            <NumberField source="size" />
            <TextField source="hash" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </SimpleShowLayout>
    </Show>
);